interface Props {
  message: string | null;
}

export default function ErrorBanner({ message }: Props) {
  if (!message) return null;
  return (
    <div className="bg-rose-50 text-rose-700 text-sm rounded-xl px-5 py-4 mb-6 border border-rose-100">
      {message}
    </div>
  );
}
